import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import {
  ETAT_ENCOURS,
  ETAT_ENREGISTRE,
  NORMAL,
  TYPE_DEVIS,
} from '@/configuration/devisConf';
import { AUCUN } from '@/configuration/optionBlocage/optionBlocage';
import genererGuid from '@/services/general/genererGuid';
import { CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';
import genererIntervenant from '@/services/devisCommandes/genererIntervenant';
import { addReferenceEcheancierToLigneCommande } from '@/services/commande/echeancierFacturation/addReferenceEcheancierToLigneCommande';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';
import formatDate from '@/services/general/formatIsoDate';
import { getLignesSelectionFace } from '@/services/dcf/reseauTempo/getListeFacesForSelection';

async function verifVentePartielle(ligne, societeId) {
  if (ligne.ligneReseau.lignesCmdSelProduits.length === 0) return [];
  const msgAvertissementVentePartielle = [];
  const listeFaceVentePartielle = await getLignesSelectionFace(
    ligne, false, [], societeId, false,
  );
  const faces = listeFaceVentePartielle.filter((f) => { return f.selected && !f.dispo; });
  if (!faces) return [];
  ligne.ligneReseau.lignesCmdSelProduits = ligne.ligneReseau.lignesCmdSelProduits.filter((l) => {
    return !faces.map(f => f.produitId).includes(l.produitId);
  });
  faces.forEach((f) => {
    msgAvertissementVentePartielle.push({
      message: 'validationCommande.faceDelete',
      parametres: {
        face: f.reference,
        reseau: ligne.produit.reference,
        semaine: ligne.ligneReseau.anneeSemaine.toString().substring(4, 6),
      },
    });
  });
  return msgAvertissementVentePartielle;
}

function updateAllDateInCmd(cmd, oldDate) {
  const days = moment(cmd.datePremierAffichage).diff(moment(oldDate), 'days');
  cmd.dateDevisCommande = new Date();
  cmd.dateValidite = formatDate(cmd.dateValidite);
  cmd.dateValidite = cmd.dateValidite ? new Date(moment(cmd.dateValidite).add(days, 'd').toDate()) : null;
  cmd.lignesCommande.forEach(async (ligne) => {
    if (ligne.typeProduit === CATEGORIE_REGROUPEMENT) {
      ligne.dateDebut = new Date(moment(ligne.dateDebut).add(days, 'd').toDate());
      ligne.dateFin = new Date(moment(ligne.dateFin).add(days, 'd').toDate());
      ligne.ligneReseau.anneeSemaine = Number(getAnneeSemaineFromDate(ligne.dateDebut));
      ligne.ligneReseau.lignesCmdSelProduits.forEach(sel => {
        delete sel.id;
        sel.anneeSemaine = ligne.ligneReseau.anneeSemaine;
      });
      ligne.lignesCommande.forEach((ligneEnfant) => {
        ligneEnfant.ligneReseau.anneeSemaine = ligne.ligneReseau.anneeSemaine;
      });
      const msg = await verifVentePartielle(ligne, cmd.societeId);
      cmd.msgAvertissementVentePartielle = cmd.msgAvertissementVentePartielle.concat(msg);
    } else {
      ligne.dateDebut = ligne.dateDebut ? new Date(moment(ligne.dateDebut).add(days, 'd').toDate()) : null;
      ligne.dateFin = ligne.dateFin ? new Date(moment(ligne.dateFin).add(days, 'd').toDate()) : null;
    }
  });
  cmd.echeanciers.forEach((echeancier) => {
    echeancier.dateDebut = echeancier.dateDebut ? new Date(moment(echeancier.dateDebut).add(days, 'd').toDate()) : null;
    echeancier.dateFin = echeancier.dateFin ? new Date(moment(echeancier.dateFin).add(days, 'd').toDate()) : null;
    echeancier.dateFinPremiereEcheance = echeancier.dateFinPremiereEcheance ? new Date(moment(echeancier.dateFinPremiereEcheance).add(days, 'd').toDate()) : null;
    echeancier.echeancierLignes.forEach(ligne => {
      ligne.dateDebut = ligne.dateDebut ? new Date(moment(ligne.dateDebut).add(days, 'd').toDate()) : null;
      ligne.dateFin = ligne.dateFin ? new Date(moment(ligne.dateFin).add(days, 'd').toDate()) : null;
      ligne.datePrevisionnelleFacturation = ligne.datePrevisionnelleFacturation ? new Date(moment(ligne.datePrevisionnelleFacturation).add(days, 'd').toDate()) : null;
    });
  });
}

export default function genererCopyDevisCommande(devisCommande, newDateCmd) {
  const copy = cloneDeep(devisCommande);
  copy.acomptesAffectes = [];
  copy.code = null;
  copy.datePremierAffichage = new Date(newDateCmd);
  if (copy.datePremierAffichage) copy.datePremierAffichage = new Date(copy.datePremierAffichage);
  copy.creationTime = null;
  copy.etat = ETAT_ENREGISTRE;
  copy.etatRenouvellement = ETAT_ENCOURS;
  copy.devisCommandeInitialeId = null;
  copy.id = null;
  copy.estSigne = false;
  copy.intervenants.forEach(inter => {
    inter.id = null;
  });
  copy.intervenants.push(genererIntervenant());
  copy.lignesCommande.forEach(ligne => {
    delete ligne.isAffecteLogistiquement;
    ligne.commandeId = null;
    ligne.id = null;
    if (ligne.typeProduit === CATEGORIE_REGROUPEMENT) {
      ligne.etatDeLaDemande = true;
      ligne.etatProvisoire = AUCUN;
      ligne.etatObtenu = AUCUN;
      ligne.messagesAvertissement = null;
      ligne.rangOption = null;
    }
    ligne.lignesCommande.forEach(el => {
      delete el.isAffecteLogistiquement;
      el.id = null;
      el.etatDeLaDemande = false;
    });
    ligne.lignesRemise.forEach(el => {
      el.id = null;
    });
    ligne.lignesCmdSelOptionProduit = ligne.lignesCmdSelOptionProduit?.map((el) => {
      delete el.id;
      return el;
    }) || [];
  });
  copy.referenceId = null;
  copy.msgAvertissementVentePartielle = [];
  copy.repartitionsTva.forEach(rep => {
    rep.id = null;
  });
  if (!copy.echeanciers || copy.echeanciers.length === 0) {
    if (copy.type === TYPE_DEVIS) copy.gestionEcheancier = false;
    copy.lignesCommande.forEach((ligne) => {
      if (ligne.type === NORMAL) addReferenceEcheancierToLigneCommande(ligne, copy);
      if (ligne.lignesCommande) {
        ligne.lignesCommande.forEach((ligneEnfant) => {
          if (ligneEnfant.type === NORMAL) addReferenceEcheancierToLigneCommande(ligneEnfant, copy);
        });
      }
    });
    updateAllDateInCmd(copy, devisCommande.datePremierAffichage);
    return copy;
  }
  if (copy.type === TYPE_DEVIS) copy.gestionEcheancier = true;
  copy.echeanciers.forEach(echeancier => {
    echeancier.openEcheancierLignes = !!echeancier.quantitePeriodicite;
    echeancier.echeancierLignes.forEach(ligne => {
      ligne.id = genererGuid();
      ligne.fromGeneration = true;
      ligne.factureId = null;
      ligne.facturationFaite = false;
    });
    echeancier.id = genererGuid();
  });
  updateAllDateInCmd(copy, devisCommande.datePremierAffichage);
  return copy;
}
